
  /* eslint-disable */
  import { Swiper } from 'swiper/vue/swiper.js';
  import SwiperCore, { Navigation, Pagination } from 'swiper';
  import { defineComponent, watch, onMounted, inject, nextTick, ref } from 'vue';

  SwiperCore.use([Navigation, Pagination]);
  export default defineComponent({
    components: {
      Swiper,
    },
    props: {
      pagination: {
        type: Boolean,
        default: false,
      },
      swiperOptions: {
        type: Object,
        default: {
          speed: 500,
          threshold: 10,
          watchOverflow: true,
          followFinger: true,
          navigation: {
            prevEl: '.ce-gallery-btn--prev',
            nextEl: '.ce-gallery-btn--next',
          },
          pagination: {
            el: '.ce-gallery-pagination',
            clickable: true,
          },
        },
      },
    },

    setup() {
      let mainSwiper = ref<SwiperCore | null>(null);
      const lazyLoad = inject<any>('lazyLoad');

      const setSwiper = (swiper: SwiperCore) => {
        mainSwiper.value = swiper;
      };

      const onSlideChange = () => {
        const video = mainSwiper.value?.slides[mainSwiper.value?.previousIndex].querySelector<HTMLVideoElement>('.ce-gallery-item');
        switch (video?.tagName) {
          case 'VIDEO':
            video?.pause();
            break;
          case 'IFRAME':
            // TODO: stop youtube and vimeo (possibly also mp4 by one player event)
            break;
          default:
            break;
        }
      };

      const onSwiperInit = (swiper: SwiperCore) => {
        // console.log("init");
      };

      onMounted(() => {
        lazyLoad.update();
      });

      return {
        setSwiper,
        onSwiperInit,
        onSlideChange,
      };
    }
  });
